import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import store from './app/store/store';
import { loadUser } from "./app/store/actions/authActions";
import 'bootstrap/dist/css/bootstrap.css';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import Buffer from 'buffer'

/** Benign browser noise from MUI/layout; CRA dev overlay treats it as fatal. */
const RESIZE_OBSERVER_LOOP_RE =
  /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;
window.addEventListener(
  'error',
  (event) => {
    if (event?.message && RESIZE_OBSERVER_LOOP_RE.test(event.message)) {
      event.stopImmediatePropagation();
    }
  },
  true
);

store.dispatch(loadUser());

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
